export default __webpack_public_path__ + "static/1295-c403065e8ba0df8780e92d1c667d717f.gif";